import { render } from "./Grid.vue?vue&type=template&id=0dff7092"
import script from "./Grid.vue?vue&type=script&lang=ts"
export * from "./Grid.vue?vue&type=script&lang=ts"
script.render = render

export default script